import { CancellationDetails } from '@core/classes/CancelCoverage/CancellationDetails';
import { CancellationRequest } from '@core/classes/Requests/CancellationRequest';
import { CancellationResponse } from '@core/classes/Responses/CancellationResponse';
import moment from 'moment';
import request from '@core/services/request';
import SaturnResponse from '@core/classes/Responses/SaturnResponse';

export const cancelCoverageAPI = {
	getCancellationQuote: (requestObj: any) => request.post(`/CancelCoverage/GetCancellationQuote`, requestObj),
	cancelProduct: (requestObj: CancellationRequest) =>
		request.post<CancellationRequest, SaturnResponse<CancellationResponse>>(`/CancelCoverage/CancelProduct`, requestObj),
	searchCancellations: (requestObj: any) => request.post(`/CancelCoverage/SearchCancellations`, requestObj),
	downloadCancellations: (requestObj: any) => {
		const date = new Date();
		const formattedDate = moment(date, ['MM/DD/YYYY', 'YYYY-MM-DDTHH:mm:ss.SSSZ']).format('YYYYMMDDhhhmmss');
		return request.downloadPost(`/CancelCoverage/DownloadCancellations`, requestObj, 'cancellations-' + formattedDate + '.xlsx');
	},
	downloadCancellationForm: (id: any, lang: any, cancellationReason: any) =>
		request.downloadPost(
			`/CancelCoverage/DownloadCancellationForm`,
			{
				CancellationId: id,
				Language: lang,
				CustomerCancellationReason: cancellationReason,
			},
			`CancellationForm-${id}.pdf`,
		),
	submitCancellationForm: (data: any) => request.post('/CancelCoverage/SubmitCancellationForm', data),
	resendCancellationCustomerEmail: (cancellationId: any) => request.post(`/CancelCoverage/ResendCancellationCustomerEmail?cancellationId=${cancellationId}`),
	updateCancellation: (cancellation: any, user: any, operation: any) =>
		request.post<{ cancellation: any; user: any; operation: any }, CancellationDetails>(
			`/CancelCoverage/UpdateCancellation?user=${user}&operation=${operation}`,
			cancellation,
		),
	getCancellationDetails: (cancellationId: string) => request.get<CancellationDetails>(`/CancelCoverage/GetCancellationDetails/${cancellationId}`),
	getCancellationStatusList: (editable: any) => request.get(`/CancelCoverage/GetCancellationStatusList?editable=${editable ? 'true' : 'false'}`),
	searchProductCancellations: (searchFields: any) =>
		request.post(`/CancelCoverage/SearchProductCancellations`, {
			fieldsToSearch: searchFields,
		}),
};
